<div *ngIf="loading$ | async" fxFill fxLayout="column" fxLayoutAlign="center center">
  <mat-spinner></mat-spinner>
  <p>Loading energy sources</p>
</div>

<div fxFlexFill fxLayout="column" [style.display]="(loading$ | async) ? 'none' : 'flex'">

  <mat-table fxFlex class="mat-elevation-z8" [dataSource]="dataSource">

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>Energy Source</mat-header-cell>
      <mat-cell *matCellDef="let source">{{source.fuelId | typeTranslate : source.countryCode}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="co2Factor">
      <mat-header-cell *matHeaderCellDef>CO2 Factor (kg/kWh)</mat-header-cell>
      <mat-cell *matCellDef="let source">
        <div fxFlex class="input-container">
          <mat-form-field fxFlex appearance="outline">
            <input matInput type="number" step="any" [(ngModel)]="source.co2Factor">
            <button mat-icon-button matSuffix
                    *ngIf="dataSource.hasCo2FactorChanged(source)"
                    matTooltip="Reset" (click)="dataSource.resetCo2Factor(source)">
              <mat-icon>undo</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="calorificValue">
      <mat-header-cell *matHeaderCellDef>Calorific Value</mat-header-cell>
      <mat-cell *matCellDef="let source">
        <div fxFlex class="input-container">
          <mat-form-field fxFlex appearance="outline">
            <input matInput type="number" step="any" [(ngModel)]="source.calorificValue">
            <button mat-icon-button matSuffix
                    *ngIf="dataSource.hasCalorificValueChanged(source)"
                    matTooltip="Reset" (click)="dataSource.resetCalorificValue(source)">
              <mat-icon>undo</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="unit">
      <mat-header-cell *matHeaderCellDef>Unit</mat-header-cell>
      <mat-cell *matCellDef="let source">{{source.unit}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="lastModifiedBy">
      <mat-header-cell *matHeaderCellDef>Modified By</mat-header-cell>
      <mat-cell *matCellDef="let source">{{source.lastModifiedBy}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="lastModifiedDate">
      <mat-header-cell *matHeaderCellDef>Modified Date</mat-header-cell>
      <mat-cell *matCellDef="let source">{{source.lastModifiedDate | date:'medium'}}</mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>

  <button fxFlex="0 1 auto" mat-raised-button class="submit-button" color="primary" (click)="submit()">Submit</button>
</div>
